module.exports = __webpack_public_path__ + "img/gw.91bc0afe.svg";